"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parsePluginVersionFromStdout = void 0;
exports.parseMavenDependencyTree = parseMavenDependencyTree;
const stdout_1 = require("./stdout");
const digraph_1 = require("./digraph");
var stdout_2 = require("./stdout");
Object.defineProperty(exports, "parsePluginVersionFromStdout", { enumerable: true, get: function () { return stdout_2.parsePluginVersionFromStdout; } });
function parseMavenDependencyTree(stdout, mavenVerboseIncludeAllVersions = false, versionResolver) {
    const digraphs = (0, stdout_1.parseDigraphsFromStdout)(stdout);
    const mavenGraphs = (0, digraph_1.parseDigraphs)(digraphs, {
        mavenVerboseIncludeAllVersions,
    }, versionResolver);
    return { mavenGraphs };
}
//# sourceMappingURL=dependency-tree-parser.js.map